import { render } from "./InfluenciaEcosistemas.vue?vue&type=template&id=3b4d8db0"
import script from "./InfluenciaEcosistemas.vue?vue&type=script&lang=js"
export * from "./InfluenciaEcosistemas.vue?vue&type=script&lang=js"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__